import { render, staticRenderFns } from "./CurrentLeasesTabScreen.vue?vue&type=template&id=efda7cf8&"
import script from "./CurrentLeasesTabScreen.vue?vue&type=script&lang=js&"
export * from "./CurrentLeasesTabScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efda7cf8')) {
      api.createRecord('efda7cf8', component.options)
    } else {
      api.reload('efda7cf8', component.options)
    }
    module.hot.accept("./CurrentLeasesTabScreen.vue?vue&type=template&id=efda7cf8&", function () {
      api.rerender('efda7cf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/leases/screens/LeasesScreen/CurrentLeasesTabScreen.vue"
export default component.exports